import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'
import { showFieldError, renderValidation } from '../../../../../utils/validations'
import { getExceptionMessage } from '../../../../../utils/exceptions'
import Button from '../../../../../components/Button'
import FormRow from '../../../../../components/FormFields/FormRow'
import TextField from '../../../../../components/FormFields/TextField'
import FormInfo from '../../../../../components/FormFields/FormInfo'
import FormActions from '../../../../../components/FormFields/FormAction/FormActions'
import FormError from '../../../../../components/FormFields/FormError'

import { getApplyToStepPath } from '../../../../MainRoutes/utils'
import { stepStatuses } from '../../../constants'
import { StatusSteps } from '../../StatusSteps'

function SolicitudeForm({
  values,
  status = {},
  errors,
  touched,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  application
}) {
  return (
    <form onSubmit={handleSubmit}>
      <FormInfo>Cuéntanos en 2 o 3 frases el proyecto o iniciativa que quieres financiar. Recuerda que Triodos Bank financia empresas, organizaciones e inciativas que aportan un valor añadido de carácter social, medioambiental y/o cultural. Puedes obtener más información en <a href='https://www.triodos.es/es/financiacion' title='Criterios de Financiación Triodos' target='_blank' rel='noopener noreferrer'>triodos.es</a></FormInfo>
      <FormRow>
        <TextField
          type='textarea'
          name='description'
          value={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('description', { errors, touched })}
          help={renderValidation('description', { errors, touched })}
          label='Empieza a escribir aquí...'
          full
        />
      </FormRow>
      {status.error && (
        <FormError>
          <FormattedMessage {...getExceptionMessage(status.error)} />
        </FormError>
      )}
      <FormActions>
        <Button type='submit' disabled={isSubmitting}>Continuar</Button>
        <Link to={getApplyToStepPath(stepStatuses.SOLICITUDE, application)}>Volver</Link>
      </FormActions>
      <StatusSteps />
    </form>
  )
}

SolicitudeForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  status: PropTypes.shape({
    error: PropTypes.instanceOf(Error),
    success: PropTypes.object
  }),
  isSubmitting: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default SolicitudeForm
